//
//
//

import vComponent from '@/core/vComponent'
import moment from 'moment'
export default {
  name: 'Clock',
  extends: vComponent,
  computed: {},
  data () {
    return {
      clockId: null,
      timeStr: ''
    }
  },
  created () {
    this.startClock()
  },
  methods: {
    startClock () {
      if (this.clockId != null) clearInterval(this.clickId)
      this.clickId = setInterval(() => {
        this.timeStr = moment().format('HH:mm')
      }, 1000)
    }
  }
}
